module.exports = __webpack_public_path__ + "img/xiaofeng.2d85ea22.png";